import { render, staticRenderFns } from "./sk-checkbox-select-wap.vue?vue&type=template&id=5597ba9a&"
import script from "./sk-checkbox-select-wap.vue?vue&type=script&lang=js&"
export * from "./sk-checkbox-select-wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports